import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../components/LanguageSelector";

const HeaderSection = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleContactsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    closeMenu();
    
    if (location.pathname === "/") {
      // Если уже на главной странице, просто прокручиваем к футеру
      const footerElement = document.getElementById("footer");
      if (footerElement) {
        footerElement.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Если на другой странице, переходим на главную и прокручиваем к футеру
      navigate("/");
      setTimeout(() => {
        const footerElement = document.getElementById("footer");
        if (footerElement) {
          footerElement.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <>
      <header className={`w-full h-20 md:h-28 bg-neutral-50 relative z-50 ${isMenuOpen ? "hidden md:block" : ""}`}>
        <div className="h-full max-w-7xl mx-auto px-5 md:px-5 flex items-center justify-between">
          {/* Логотип */}
          <Link to="/" className="flex-shrink-0">
            <div className="w-28 h-7 bg-[url('/logo.svg')] bg-cover bg-no-repeat bg-center" />
          </Link>

          {/* Desktop навигация */}
          <nav className="hidden md:flex items-center gap-8 flex-1 justify-center">
            <Link to="/" className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80">
              {t("nav.home")}
            </Link>
            <Link to="/about" className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80">
              {t("nav.about")}
            </Link>
            <Link to="/services" className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80">
              {t("nav.services")}
            </Link>
            <Link to="/projects" className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80">
              {t("nav.projects")}
            </Link>
            <a
              href="#contacts"
              onClick={handleContactsClick}
              className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80 cursor-pointer"
            >
              {t("nav.contacts")}
            </a>
          </nav>

          {/* Desktop тіл таңдауы және телефон */}
          <div className="hidden md:flex items-center gap-6 flex-shrink-0">
            <LanguageSelector variant="desktop"  />
            <a
              href="tel:+77777503055"
              className="
                          w-56 h-14 
                          bg-red-900 
                          hover:bg-white 
                          hover:border-2 
                          hover:border-red-900 
                          flex items-center justify-center 
                          px-4 
                          text-neutral-50 
                          text-base 
                          font-medium 
                          font-['Inter'] 
                          hover:text-red-900
                        "
            >
              +7 777 750 3055
            </a>


          </div>

          {/* Mobile hamburger */}
          <button
            onClick={toggleMenu}
            className="md:hidden flex flex-col items-center justify-center gap-1.5 w-10 h-10"
            aria-label="Toggle menu"
          >
            <div className="w-10 h-0.5 bg-red-900 transition-all" />
            <div className="w-6 h-0.5 bg-red-900 transition-all" />
            <div className="w-10 h-0.5 bg-red-900 transition-all" />
          </button>
        </div>
      </header>

      {/* Mobile sidebar overlay */}
      <>
        {/* Backdrop */}
        <div
          className={`fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity duration-500 ease-in-out ${isMenuOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
          onClick={closeMenu}
        />

        {/* Sidebar */}
        <div
          className={`fixed top-0 right-0 h-full w-[330px] bg-neutral-50 z-50 transform transition-transform duration-500 ease-in-out md:hidden ${isMenuOpen ? "translate-x-0" : "translate-x-full"
            }`}
        >
            <div className="flex flex-col h-full p-6">


              {/* Brand logo */}
              <div className="mb-8">
                <Link to="/" onClick={closeMenu} className="inline-block">
                  <div className="w-28 h-7 bg-[url('/logo.svg')] bg-cover bg-no-repeat bg-center" />
                </Link>
              </div>

              {/* Mobile навигация */}
              <nav className="flex flex-col gap-6 mb-8">
                <Link
                  to="/"
                  onClick={closeMenu}
                  className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80"
                >
                  {t("nav.home")}
                </Link>
                <Link
                  to="/about"
                  onClick={closeMenu}
                  className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80"
                >
                  {t("nav.about")}
                </Link>
                <Link
                  to="/services"
                  onClick={closeMenu}
                  className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80"
                >
                  {t("nav.services")}
                </Link>
                <Link
                  to="/projects"
                  onClick={closeMenu}
                  className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80"
                >
                  {t("nav.projects")}
                </Link>
                <a
                  href="#contacts"
                  onClick={handleContactsClick}
                  className="text-red-900 text-lg font-normal font-['Inter'] tracking-tight hover:opacity-80 cursor-pointer"
                >
                  {t("nav.contacts")}
                </a>
              </nav>

              {/* Call button */}
              <div className="w-full h-14 bg-red-900 flex items-center justify-center px-4 mb-8">
                <a href="tel:+77777503055" className="text-neutral-50 text-base font-medium font-['Inter']">
                  +7 777 750 3055
                </a>
              </div>

              {/* Language section */}
              <LanguageSelector variant="mobile" />
            </div>
          </div>
      </>
    </>
  );
};

export default HeaderSection;

